(() => {
  if (window.__velomintSizeGuideCombinedFixLoaded) return;
  window.__velomintSizeGuideCombinedFixLoaded = true;

  const SIZE_RE = /(?:^|[\s,/_-])(?:TALLA\s*|T[.\/-]?\s*)(S[-/]M|M[-/]L|L[-/]XL|XL[-/]XXL|XXS|XS|XXXL|XXL|XL|[2-6]XL|S|M|L|\d{2})(?=$|[\s,/_-])/i;

  function parseSize(raw) {
    const text = String(raw || '').trim();
    const match = text.match(SIZE_RE);
    if (!match) return null;
    const size = match[1].toUpperCase().replace(/\s+/g, '');
    return size === 'XXXL' ? '3XL' : size;
  }

  function fixRow(row) {
    if (!row || row.dataset.velomintCombinedSizesFixed === 'true') return;
    const scope = row.closest('.shopify-section') || document;
    const inputs = [...scope.querySelectorAll("variant-selects[data-velomint-smart-variants] input[type='radio']")];
    if (!inputs.length) return;

    const sizes = [];
    inputs.forEach((input) => {
      const size = parseSize(input.value);
      if (size && !sizes.includes(size)) sizes.push(size);
    });
    if (!sizes.length) return;

    row.querySelectorAll(':scope > span').forEach((span) => span.remove());
    sizes.forEach((size) => {
      const span = document.createElement('span');
      span.textContent = size;
      row.append(' ', span);
    });
    row.dataset.velomintCombinedSizesFixed = 'true';
  }

  function fixAll(root = document) {
    if (root.matches?.('.velomint-size-guide__available')) fixRow(root);
    root.querySelectorAll?.('.velomint-size-guide__available').forEach(fixRow);
  }

  const start = () => {
    fixAll();
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) fixAll(node);
      }));
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
